import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "./AuthContext";

const PublicRoute = ({ element }) => {
  const { authTokens } = useContext(AuthContext);
  return authTokens ? <Navigate to="/" replace /> : element;
};

export default PublicRoute;
